export default __webpack_public_path__ + "static/media/add-round.cbd1e271.svg";